// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"7e5d6513","292":"d317a56e"}[chunkId] + ".chunk.css";
};